import styled from 'styled-components'

export const ExampleButton = styled.button`
    background: green;
    color: orange;
    font-size: 2rem;
`
